import { useMutation, useQueryClient } from "react-query";
import { addSalesLead } from "../../../../../actions/Utilities/SalesLead";
import { toast } from "../../../../../components/toastNotification";
import { SalesLeadData } from "../types/SalesLeadInterface";

export default function useAddSalesLead() {
  const queryClient = useQueryClient();

  const { mutate } = useMutation(
    (NewData: SalesLeadData) => addSalesLead(NewData),
    {
      onSuccess: (res: any) => {
        if (res === "Duplicate") {
          toast.fire("Saving Failed", "The data already exists!", "error");
        } else {
          queryClient.invalidateQueries(["SalesLead"]);
          toast.fire("Success", "Sales Lead Added Successfully", "success");
        }
      },
      onError: (error) => {
        toast.fire("Failed", "Failed to Add Sales Lead", "error");
      },
    }
  );

  return mutate;
}
